import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const BillingMiddleware: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const { userInfo } = useSelector((state: any) => state.auth);
    if(userInfo?.user){
        if(userInfo.user.is_account_activated){
            return <>{children}</>;
        }
        else {
            return <Navigate to="/not-found" replace />;
        }
    }
    else {
        return <Navigate to="/login" replace />;
    }
    
  };

  export default BillingMiddleware;